import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">最新动态</h2>
          <span className="hidden sm:flex items-center gap-1.5 text-xs text-accent-600 cursor-pointer hover:text-accent-700 transition-colors whitespace-nowrap">
            全部动态 <i className="ri-arrow-right-line"></i>
          </span>
        </div>
        <div className="max-w-4xl mx-auto space-y-0">
          {updatesData.map((item, i) => (
            <div key={i} className="flex items-start gap-4 py-4 border-b border-background-200/70 last:border-b-0 group cursor-pointer hover:bg-background-100/70 -mx-3 px-3 rounded-lg transition-colors">
              <div className="flex-shrink-0 flex flex-col items-center pt-0.5">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                <span className="text-[10px] text-foreground-300 whitespace-nowrap">{item.time}</span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-800 leading-relaxed group-hover:text-primary-600 transition-colors">{item.title}</p>
              </div>
              <div className="flex-shrink-0 flex items-center gap-1.5 pt-0.5">
                <span className={`px-2 py-0.5 text-[10px] font-medium rounded-full whitespace-nowrap ${
                  item.tag === '内幕' || item.tag === '爆料'
                    ? 'bg-accent-100 text-accent-700'
                    : item.tag === '官宣'
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-secondary-100 text-secondary-700'
                }`}>{item.tag}</span>
                {item.hot && (
                  <span className="text-[10px] text-accent-500 font-medium whitespace-nowrap">
                    <i className="ri-fire-line mr-0.5"></i>热
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}